import { render, staticRenderFns } from "./AddToCartPopinCds.vue?vue&type=template&id=8da666fe&scoped=true"
import script from "./AddToCartPopinCds.vue?vue&type=script&lang=js"
export * from "./AddToCartPopinCds.vue?vue&type=script&lang=js"
import style0 from "./AddToCartPopinCds.vue?vue&type=style&index=0&id=8da666fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da666fe",
  null
  
)

export default component.exports